import { render, staticRenderFns } from "./WikiKnowledgeContentLinks.vue?vue&type=template&id=bac079ec&"
import script from "./WikiKnowledgeContentLinks.vue?vue&type=script&lang=js&"
export * from "./WikiKnowledgeContentLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports